///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-criteria.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ActiveInactiveCriteriaFilter extends CriteriaFilter implements ICriteriaFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: { hideInactive: boolean; };
        public readonly criteria: { ProductState_TBL: ObjectStateEnum[] };

        constructor(collections: IApiCollection<any>[], options: IDataTemplateFilterOptions = {}) {
            super(collections, options);

            this.templateName = 'active-inactive';
            this.values = {
                hideInactive: true
            };
        }

        updateCriteria() {
            const objectState: ObjectStateEnum[] = [ObjectStateEnum.Active];
            if (!this.values.hideInactive) {
                objectState.push(ObjectStateEnum.Inactive);
            }

            this.criteria.ProductState_TBL = objectState;
        }
    }
}